import PropTypes from 'prop-types';

/**
 * Selectable row used by the reminder and detection-type pickers. Renders as an accessible
 * checkbox/radio (keyboard: Space/Enter) while keeping the existing `choice-row` styling.
 */
export default function ChoiceRow({
  role = 'checkbox',
  checked,
  disabled = false,
  onToggle,
  label,
  description,
}) {
  const toggle = () => {
    if (!disabled) onToggle();
  };
  return (
    <div
      role={role}
      aria-checked={checked}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : 0}
      className={`choice-row ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}
      onClick={toggle}
      onKeyDown={(e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          toggle();
        }
      }}
    >
      <div className={role === 'radio' ? 'custom-radio' : 'custom-checkbox'} aria-hidden="true" />
      <div className="choice-row-content">
        <span className="choice-row-label">{label}</span>
        {description && <p className="choice-row-desc">{description}</p>}
      </div>
    </div>
  );
}

ChoiceRow.propTypes = {
  role: PropTypes.oneOf(['checkbox', 'radio']),
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  label: PropTypes.node.isRequired,
  description: PropTypes.node,
};
